import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          This collect event is finished.
        </p>
        <a
          className="App-link"
          href="https://www.bossylion.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Back to Bossy Lion Page
        </a>
      </header>
    </div>
  );
}

export default App;
